import { useEffect, useState } from 'react';
import sortBy from 'lodash.sortby';

const parseRefinementOptions = algoliaItems => {
    const optionsForDisplay = [];

    // Parse parents
    algoliaItems.forEach(algoliaItem => {
        const { label } = algoliaItem;

        if (label.includes(' > ')) {
            return;
        }

        optionsForDisplay.push({
            ...algoliaItem,
            children: [],
        });
    });

    // Parse children
    algoliaItems.forEach(algoliaItem => {
        const { label } = algoliaItem;

        if (!label.includes(' > ')) {
            return;
        }

        const labelParsed = label.split(' > ');
        const parentIndex = optionsForDisplay.findIndex(option => option.label === labelParsed[0]);

        if (parentIndex < 0) {
            return;
        }

        optionsForDisplay[parentIndex].children.push(algoliaItem);
    });

    // Sort children
    optionsForDisplay.forEach(option => {
        option.children = sortBy(option.children, 'label');
    });

    return optionsForDisplay;
};

export const useOptions = ({ algoliaItems, filterText }) => {
    const [options, setOptions] = useState();

    useEffect(() => {
        const parsed = parseRefinementOptions(algoliaItems);
        const filtered = parsed.filter(option => option.label.toUpperCase().includes(filterText.toUpperCase()));
        const sorted = sortBy(filtered, 'label');
        setOptions(sorted);
    }, [algoliaItems, filterText]);

    return { options };
};

export const useCurrentSelections = ({ algoliaCurrentRefinement }) => {
    const [currentSelections, setCurrentSelections] = useState([]);

    useEffect(() => {
        setCurrentSelections(
            algoliaCurrentRefinement.map(refinement => {
                let label = refinement;

                if (refinement.includes(' > ')) {
                    label = refinement.split(' > ')[1]; // eslint-disable-line
                    if (label.includes('-')) {
                        label = label.split('-')[1]; // eslint-disable-line
                    }
                }

                return {
                    value: refinement,
                    label,
                };
            })
        );
    }, [algoliaCurrentRefinement]);

    return { currentSelections };
};
